var render, staticRenderFns
import script from "./Bus.vue?vue&type=script&lang=ts&"
export * from "./Bus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bus.vue"
export default component.exports